// @file Composable to track AI response time in surface AI chat.
import { createSharedComposable } from '@vueuse/core'
import { ref } from 'vue'

const useSurfaceAiResponseTimeTracker = createSharedComposable(() => {
  const responseTimeInSeconds = ref<number>(0)
  const responseTimeIntervalId = ref<number | null>(null)

  const startResponseTimeTracking = () => {
    if (responseTimeIntervalId.value !== null) {
      clearInterval(responseTimeIntervalId.value)
      responseTimeIntervalId.value = null
    }
    responseTimeInSeconds.value = 0
    responseTimeIntervalId.value = window.setInterval(() => {
      responseTimeInSeconds.value++
    }, 1000)
  }

  const stopResponseTimeTracking = () => {
    if (responseTimeIntervalId.value === null) return
    clearInterval(responseTimeIntervalId.value)
    responseTimeIntervalId.value = null
  }

  return {
    responseTimeInSeconds,
    startResponseTimeTracking,
    stopResponseTimeTracking,
  }
})

export { useSurfaceAiResponseTimeTracker }
